import { Carousel } from 'react-responsive-carousel';
import * as Styles from './styles';
import { Banner } from '../../types';
import { useTheme } from '../../contexts/Theme';
import { useAnalytics } from '../../v2/third-party-integration/amplitude';
import { AMPLITUDE_EVENTS } from '../../constants';
import { Button } from '../Buttons/Button';
import { useTranslation } from "react-i18next";
import { useState, useEffect} from 'react';
import { getLocalizedValues } from "../UnifyAdministration/utils";
import { useUserProfile } from '../../hooks/queries';

export default function BannerItems({
  bannerItems,
  closetColor
}: {
  bannerItems: Banner[];
  closetColor: any;
}) {
  const { darkMode } = useTheme();
  const {data:userProfile} = useUserProfile();

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    bannerItems.forEach((item, idx) => {
      item.index = idx;
    });
    setActiveIndex(0);
  }, [bannerItems]);

  useEffect(() => {
    if (activeIndex === bannerItems.length - 1) {
      const timer = setTimeout(() => {
        setActiveIndex(0);
      }, 150000);

      return () => clearTimeout(timer);
    }
  }, [activeIndex, bannerItems.length]);

  const getIndicatorStyles = () => {
    return {
      background: darkMode ? '#CCCCCC' : '#4D4D4D',
      borderRadius: '16px',
      cursor: 'pointer',
      display: 'inline-block',
      height: '12px',
      margin: '0 8px',
      width: '12px',
    };
  };
  /* i18n translation*/

  const { t:translate } = useTranslation()
    const BANNER_TRANSLATE_KEY = 'banner'

  const swipeStartHandler = (item: any) => {
    setActiveIndex(item);
  }

  const { trackEvent } = useAnalytics();
  const handleLearnMore = (carouselItem: Banner) => {
    trackEvent(AMPLITUDE_EVENTS.CAMPAIGN_ACTIONS, {
      'Action': 'Learn More',
      'Carousel Item': getLocalizedValues(userProfile, carouselItem, "name").name,
    });
    window.open(carouselItem.link, '_blank')
  };
  

  return (
    <div data-testid="carouselContainer">
      <Carousel
        selectedItem={activeIndex}
        autoPlay={true}
        interval={150000}
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        onChange={swipeStartHandler}
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          if (isSelected) {
             setActiveIndex(index);
            return (
              <li
                aria-label={`Selected: ${label} ${index + 1}`}
                style={{
                  ...getIndicatorStyles(),
                  background: darkMode ? '#4D4D4D' : '#CCCCCC',
                }}
                title={`Selected: ${label} ${index + 1}`}
              />
            );
          }
          return (
            <li
              aria-label={`${label} ${index + 1}`}
              key={index}
              onClick={onClickHandler}
              onKeyDown={onClickHandler}
              role="button"
              style={getIndicatorStyles()}
              tabIndex={0}
              title={`${label} ${index + 1}`}
              value={index}
            />
          );
        }}
      >
        { bannerItems.map((carouselCard) => {
          const localizedName = getLocalizedValues(userProfile, carouselCard, "name").name;
          const localizedDescription = getLocalizedValues(userProfile, carouselCard, "description").description;
          const localizedLinkText = getLocalizedValues(userProfile, carouselCard, "linkText").linkText;
            return (
            <Styles.BannerCardContainer key={carouselCard.id}>
              <Styles.BannerImage data-testid="banner-image"
                id={carouselCard.id}
                url={carouselCard.showLogo? darkMode ? carouselCard.darkLogo : carouselCard.logo : ''}
              />
              <Styles.BannerContent>
                <Styles.BannerIntro>{localizedName}</Styles.BannerIntro>
                <Styles.BannerDescription>
                  {localizedDescription}
                </Styles.BannerDescription>
                <Styles.BannerContentFooter>
                    {(carouselCard.link !== undefined && carouselCard.link.trim() !== "") &&
                      <Button style={{ marginRight: '29px' }} data-testid="learn-more-btn"
                        darkMode={darkMode}
                        onClick={() => handleLearnMore(carouselCard)}
                        rel="noreferrer"
                        target="_blank"
                        text={localizedLinkText !== undefined && (localizedLinkText).trim() !== ""
                          && (localizedLinkText).trim().toLowerCase() !== "learn more" ? localizedLinkText : translate(`${BANNER_TRANSLATE_KEY}.learn_more`)}
                        tabIndex={carouselCard.index === activeIndex ? 0 : -1}
                      />
                    }
                </Styles.BannerContentFooter>
              </Styles.BannerContent>
            </Styles.BannerCardContainer>
          );
        }) }
      </Carousel>
    </div>
  );
}
